module.exports = __webpack_public_path__ + "img/cyanQunfa.917cde6f.png";